module.exports = __webpack_public_path__ + "static/media/favebiz-cashback.645c39ea.jpg";